import { render, staticRenderFns } from "./EmployeeLeaves.vue?vue&type=template&id=223053ca&scoped=true"
import script from "./EmployeeLeaves.vue?vue&type=script&lang=js"
export * from "./EmployeeLeaves.vue?vue&type=script&lang=js"
import style0 from "./EmployeeLeaves.vue?vue&type=style&index=0&id=223053ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223053ca",
  null
  
)

export default component.exports